<section>
  <div class="mb-5">
    <app-navbar></app-navbar>
  </div>
  <main aria-live="polite">
    <router-outlet></router-outlet>
  </main>
</section>
<app-footer></app-footer>
